import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { State } from '../store';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class ReferralsGuard {
  constructor(private router: Router,
    private store: Store<State>,) { }

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    if (localStorage.getItem('currentUser')) {
      // logged in so return true
      let hasPermission = false;
      let hasFeatureSetting = false;

      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        hasPermission = permissionIDs && !!permissionIDs.find(p =>
          p === 3305 || p === 3306 //Employee Referral view/manage
        );
      });

      this.store.select(s => s.accountState.featureSettingsIds).subscribe(featureSettingsIds => {
        hasFeatureSetting = featureSettingsIds && (!!featureSettingsIds.find(p => p === 3008)); //Referral
      });

      return hasPermission && hasFeatureSetting;
    } else {

      // not logged in so redirect to login page with the return url
      if (state.url) {
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      } else {
        this.router.navigate(['/login']);
      }
    }
    return false;
  }
}
